import { Route, Routes } from "react-router-dom";

// Internal Imports
import Home from "../common/pages/Home/Home";
import IFrame from "../common/pages/Iframe/IFrame";
import NotFound from "../common/pages/NotFound/NotFound";
import { useAuth } from "../contexts/auth";
import { IMenu, LinkRuta, LinkTipo } from "../interfaces/IMenu";
import Atributos from "../moduls/Atributos/Atributos";
import packProps from '../../package.json';
import GrupoPreguntas from "../moduls/GrupoPreguntas/GrupoPreguntas";
import GrupoUsuarios from "../moduls/GrupoUsuarios/GrupoUsuarios";
import Usuarios from "../moduls/Usuarios/Usuarios";
import ListadoClientes from "../moduls/ListadoClientes/ListadoClientes";
import Formularios from "../moduls/Formularios/Formularios";
import ListadoEncuesta from "../moduls/Encuesta/ListadoEncuesta";
import EntidadEncuesta from "../moduls/Encuesta/EntitdadesEncuesta/EntidadEncuesta";
import DetalleEntidadEncuestada from "../moduls/Encuesta/DetalleEntidadEncuestada/DetalleEntidadEncuestada";
import SequentialSurvey from "../moduls/Encuesta/SequentialSurvey/SequentialSurvey";
import EncuestaNoSequencial from "../moduls/Encuesta/NoSequentialSurvey/EncuestaNoSequencial";
import RespuestaFormulario from "../moduls/Historico/RespuestaFormulario/RespuestaFormulario";
import ListadoHistoricoAvanzado from "../moduls/Historico/ListadoHistoricoAvanzado";
import HistoricoEntidadUsuario from "../moduls/Historico/HistoricoEntidadEncuestada/HistoricoEntidadUsuario/HistoricoEntidadUsuario";
import HistoricoEntidadAvanzada from "../moduls/Historico/HistoricoEntidadEncuestada/HistoricoEntidadAvanzada/HistoricoEntidadAvanzada";
import ListadoHistorico from "../moduls/Historico/ListadoHistorico";

const AppRoutes = () => {
    const { menuPlane } = useAuth();

    const getComponent = (menu: IMenu): JSX.Element => {
        let component = <></>;

        if (menu.linkTipo == LinkTipo.IFrame) {
            component = <IFrame menu={menu} />
        } else {
            switch (menu.link) {
                case LinkRuta.Principal:
                    component = <Home pageName={menu.nombre} />
                    break;
                case LinkRuta.Atributos:
                    component = <Atributos menu={menu} />
                    break;
                case LinkRuta.Usuarios:
                    component = <Usuarios menu={menu} />
                    break;
                case LinkRuta.GrupoUsuarios:
                    component = <GrupoUsuarios menu={menu} />
                    break;
                case LinkRuta.Listados:
                    component = <ListadoClientes menu={menu} />
                    break;
                case LinkRuta.GrupoPreguntas:
                    component = <GrupoPreguntas menu={menu} />
                    break;
                case LinkRuta.Formularios:
                    component = <Formularios menu={menu} />
                    break;
                case LinkRuta.Encuesta:
                    component = <ListadoEncuesta menu={menu} />
                    break;
                case LinkRuta.HistoricoUsuario:
                    component = <ListadoHistorico menu={menu} />
                    break;
                case LinkRuta.Historico:
                    component = <ListadoHistoricoAvanzado menu={menu} />
                    break;
                default:
                    component = <NotFound />
                    break;
            }
        }

        return component;
    }

    return (
        <Routes>
            {menuPlane.current.map((menu: IMenu) => (
                <Route key={menu.link} path={packProps.homepage + menu.link} element={getComponent(menu)} />
            ))}
            <Route key={'EntidadEncuesta'} path="/EntidadEncuesta" element={<EntidadEncuesta />} />
            <Route key={'HistoricoEntidadUsuario'} path="/HistoricoEntidadUsuario" element={<HistoricoEntidadUsuario/>} />
            <Route key={'HistoricoEntidadAvanzada'} path="/HistoricoEntidadAvanzada" element={<HistoricoEntidadAvanzada/>} />
            <Route key={'RespuestaFormulario'} path="/RespuestaFormulario" element={<RespuestaFormulario />} />
            <Route key={'DetalleEntidadEncuestada'} path="/DetalleEntidadEncuestada" element={<DetalleEntidadEncuestada />} />
            <Route key={'SequentialSurvey'} path="/SequentialSurvey" element={<SequentialSurvey />} />
            <Route key={'EncuestaNoSequencial'} path="/EncuestaNoSequencial" element={<EncuestaNoSequencial />} />
            <Route key={'Principal'} path="*" element={<Home pageName={"Principal"} />} />
        </Routes>
    );
}

export default AppRoutes;
